<template>

    <header class="header-global">
     
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
            
                <img src="img/little.png" alt="logo">
                
            </router-link>
            <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-lg-auto">
           
                  <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">MENU</span>
                    </a>
                    <router-link to="landing" class="dropdown-item">Landing</router-link>
                    <router-link to="report" class="dropdown-item">Reports</router-link>
                    <router-link to="staff" class="dropdown-item">Staff List</router-link>
                    <router-link to="leave" class="dropdown-item">Leave Days</router-link>
                    <router-link to="task" class="dropdown-item">Tasks</router-link>
                    <!-- <router-link to="user" class="dropdown-item">Champions</router-link> -->
                      <a @click="logout" class="btn btn-primary text-white m-2" >
                        <span class="btn-inner--icon">
                          <i class="fa fa-sign-out mr-2"></i>
                        </span>
                        <span class="nav-link-inner--text">LOGOUT</span>
                      </a>
                </base-dropdown>


              

                <!-- <li class="nav-item d-none d-lg-block ml-lg-4" @click="logout">
                    <a 
                       class="btn btn-neutral btn-icon" >
                <span class="btn-inner--icon">
                  <i class="fa fa-sign-out mr-2"></i>
                </span>
                        <span class="nav-link-inner--text">LOGOUT</span>
                    </a>
                </li> -->
            </ul>
        
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";


export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,

  },
   methods:{

     logout(){

       this.$store.dispatch('logout')
       location.reload(true);
       

     },

     report(){

      //  this.$store.dispatch('logout')
      //  location.reload(true);
       this.$router.push('report') 

     },
   
  }
};
</script>
<style>
</style>
